export default __webpack_public_path__ + "static/media/three-dot-menu.9002de15.svg";